// 码头 / 跳板: walking across to the other boat. The office raft has a pier (码头) out to the 活动舱 moored beside it; the
// 活动舱 has a gangplank (跳板) back. They are the maps' portals (deck/map.js MAP.portals: a rectangle, `to` "play" or
// "main"). When my otter's feet step onto one the page goes to that boat (public/floors.js board: the same reload as
// picking it in the boat menu, under public/voyage.js's 换船 transition), landing on the other boat's deck: the office reads
// ?arrive=dock-<this boat> on the socket (src/office/office.ts) and puts the new otter there, not at the spawn.
// Arriving on a portal (or starting on one) does nothing until you have stepped off it once.

/** o: {MAP, me(), floor (initFloors' result: board(to, arrive), kind)} */
export function initBoats({ MAP, me, floor }) {
  const here = floor.kind === 'play' ? 'play' : 'main';
  const portalAt = (p) => {
    const fx = Math.floor(p.x + 0.5), fy = Math.floor(p.y + 0.8);
    // The portal rectangle describes the whole pier (also used to align neighbours). Cross only at its water end,
    // next to the other boat, rather than as soon as the otter steps onto the middle of the bridge.
    return (MAP.portals ?? []).find((q) => fx >= q.x && fx < q.x + q.w && fy >= Math.max(q.y, q.y + q.h - 1) && fy < q.y + q.h) ?? null;
  };
  let armed = false, going = false;
  const timer = setInterval(() => {
    const m = me(); if (!m || going) return;
    const q = portalAt(m);
    if (!armed) { armed = !q; return; }
    if (!q) return;
    going = true;
    // the 换船 transition covers the page from here (public/voyage.js, through floors.js board)
    if (!floor.board?.(q.to, `dock-${here}`)) { going = false; armed = false; } // stayed (a draft to keep, or no such boat): step off and on again
  }, 120);
  return { stop: () => clearInterval(timer) };
}
